import type { FunctionComponent, PropsWithChildren } from 'react';

import { useApplicationContext } from '~/shared/context/use-application-context';
import { getKeyboardShortcutsEnabled } from '~/shared/data-contract/user-ui-settings';
import { KeyboardShortcutsProvider } from '~/ui/core/keyboard-shortcuts/KeyboardShortcutsContext';

import { useEscapeToBlur } from './use-escape-to-blur';

export const KeyboardShortcutsPolicyProvider: FunctionComponent<PropsWithChildren> = ({ children }) => {
    const {
        applicationState: { featureFlagService, uiSettings },
    } = useApplicationContext();
    const enabled =
        featureFlagService.isFeatureFlagEnabled('keyboard-shortcuts') &&
        uiSettings.mapOr(false, getKeyboardShortcutsEnabled);

    useEscapeToBlur(enabled);

    return <KeyboardShortcutsProvider enabled={enabled}>{children}</KeyboardShortcutsProvider>;
};
